import { ExtendedTicketInformation, TicketInformation } from "components/Mytask/mtDetails/mtDetails-Content/WorkTicket/interface";
import ScrollView from "devextreme-react/scroll-view";
import { Sortable } from "devextreme-react/sortable";
import { AddEvent, ReorderEvent } from "devextreme/ui/sortable";
import CardTicket from "./CardTicket";

const ListTicket: React.FC<{
    title: string;
    index: number;
    tickets: ExtendedTicketInformation[];
    onTicketDrop: (e: AddEvent | ReorderEvent) => void;
}> = ({ title, index, tickets, onTicketDrop }) => {
    return (
        <div className="list">
            <div className="list-header">
                <span className="list-dot" />
                <span>{title}</span>
                <span className="task-count">{tickets.length}</span>
            </div>
            <ScrollView className="scrollable-list" direction="vertical" showScrollbar="always">
                <Sortable
                    className="sortable-cards"
                    group="cardsGroup"
                    data={index}
                    onReorder={onTicketDrop}
                    onAdd={onTicketDrop}
                >
                    {tickets.map((ticket) => (
                        <CardTicket key={ticket.id} ticket={ticket} />
                    ))}
                </Sortable>
            </ScrollView>
        </div>
    );
};

export default ListTicket;